import { cx } from "shared/utils";

interface Props {
  title?: string;
  gap?: "sm" | "md";
  children: React.ReactNode;
}

export const FormSection = ({ title, gap = "md", children }: Props) => (
  <div className={cx("flex flex-col", gap === "sm" ? "gap-2" : "gap-3")}>
    {title && <h3 className="text-content-200 text-sm font-medium">{title}</h3>}
    {children}
  </div>
);
